<template>
    <div class="subscription--layer">
        <div class="subscription--overlay">
            <div class="subscription--container">
                <div class="subscription--content">
                    
                    <div class="subscription--header">
                        <div class="top">
                            <p>{{ translations.subscription.register }}</p>
                            <button class="close" @click.prevent="close">
                                <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.00048 1.42896L15.1426 15.5711M15.1421 1.42896L1 15.5711" stroke="currentColor" stroke-width="2"/>
                                </svg>                            
                            </button>
                        </div>
                        <div class="progression" v-if="screen && screen.steps && screen.steps.step_current && screen.steps.step_count">
                            <div class="progression--wrapper">
                                <div class="progression--bar" :style="{'--track-width': track }">
                                    <div class="progression--track"></div>
                                </div>
                            </div>
                            <div class="progression--label">{{ translations.subscription.step }} {{ screen.steps.step_current }}/{{ screen.steps.step_count }}</div>
                        </div>
                    </div>

                    <component v-bind:is="screenView" :data="screen" />

                    <div class="subscription--footer" v-if="screen && screen.back.back_target">
                        <a :href="prettyAnchor(screen.back.back_target)">
                            <svg width="7" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1 2 5l4 4" stroke="currentColor" stroke-width="2"/></svg>
                            {{ screen.back.back_label }}
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubscriptionScreenLoader from './SubscriptionLoader.vue'
import SubscriptionScreenButtons from './SubscriptionButtons.vue'
import SubscriptionScreenText from './SubscriptionText.vue'
import SubscriptionScreenError from './SubscriptionError.vue'
import SubscriptionEvents, { SubscriptionEventType } from '../components/subscription-event'

export default {
    name: 'SubscriptionScreen',

    components: {
        SubscriptionScreenLoader,
        SubscriptionScreenButtons,
        SubscriptionScreenText,
        SubscriptionScreenError
    },

    props: {
        screen: Object,
        view: {
            type: String,
            default: 'Loader'
        }
    },

    data () {
        return {
            translations: window.script_var.translations
        }
    },

    computed: {
        screenView () {
            return `SubscriptionScreen${this.view}`
        },

        track () {
            return this.screen && this.screen.steps.step_current && this.screen.steps.step_count ? `${100 * this.screen.steps.step_current / this.screen.steps.step_count}%` : 0
        }
    },

    methods: {
        close () {
            SubscriptionEvents.$emit(SubscriptionEventType.CLOSE)
        },

        prettyAnchor (target) {
            return `#${target}`
        }
    }
}
</script>
